module.exports = __webpack_public_path__ + "static/potions-1eb792ef1699b9f03c965746548d5a9a.jpg";